/* stylelint-disable */
:host {
  display: block;
  height: 100%;
}

:host .highlight-naming {
  font-weight: 400;
}

:host .highlight-naming .accent {
  font-weight: 700;
}

.pes-ellipsis {
  overflow: hidden;
  text-align: center;
}

.pes-ellipsis a {
  display: inline-block;
  border-radius: var(--qds-focus-border-radius);
  box-sizing: border-box;
  text-decoration: underline;
  color: var(--qds-theme-link-standard-default);
}

.pes-ellipsis a:visited {
  color: var(--qds-theme-link-standard-visited);
}

.pes-ellipsis a:hover {
  color: var(--qds-theme-link-standard-hover);
}

.pes-ellipsis a:active {
  color: var(--qds-theme-link-standard-pressed);
}

.pes-ellipsis a:visited:hover {
  color: var(--qds-theme-link-standard-visited-hover);
}

.pes-ellipsis a:visited:active {
  color: var(--qds-theme-link-standard-visited-pressed);
}

.pes-ellipsis a[rel~=external] > .qds-external {
  display: inline-block;
}

.pes-ellipsis a:focus-visible {
  outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
}

.pes-ellipsis a[aria-disabled=true] {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}

.pdp-long-desc a {
  display: inline-block;
  border-radius: var(--qds-focus-border-radius);
  box-sizing: border-box;
  text-decoration: underline;
  color: var(--qds-theme-link-standard-default);
}

.pdp-long-desc a:visited {
  color: var(--qds-theme-link-standard-visited);
}

.pdp-long-desc a:hover {
  color: var(--qds-theme-link-standard-hover);
}

.pdp-long-desc a:active {
  color: var(--qds-theme-link-standard-pressed);
}

.pdp-long-desc a:visited:hover {
  color: var(--qds-theme-link-standard-visited-hover);
}

.pdp-long-desc a:visited:active {
  color: var(--qds-theme-link-standard-visited-pressed);
}

.pdp-long-desc a[rel~=external] > .qds-external {
  display: inline-block;
}

.pdp-long-desc a:focus-visible {
  outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
}

.pdp-long-desc a[aria-disabled=true] {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}

.tooltip-wrapper {
  display: flex;
  align-items: center;
}

.tooltip-wrapper-centered {
  justify-content: center;
}

pes-tooltip-wrapper.tooltip-wrapper-left {
  justify-content: flex-start;
}

@media screen and (max-width: 979px) {
  .tooltip-wrapper {
    justify-content: center;
  }
}

:host(:not([dir="rtl"])) div.pes-ellipsis-card {
  text-align: left;
}

:host([dir="rtl"]) div.pes-ellipsis-card {
  text-align: right;
}